const STORAGE_KEY = 'aichat_site_unlock_state'
const DEFAULT_PASSWORD = 'aichat'
const DEFAULT_UNLOCK_DAYS = 30

function getConfiguredPassword() {
    return process.env.VUE_APP_SITE_PASSWORD || DEFAULT_PASSWORD
}

function getStorage() {
    if (typeof window === 'undefined') return null
    try {
        return window.localStorage
    } catch {
        return null
    }
}

function getUnlockDays() {
    const rawDays = Number(process.env.VUE_APP_SITE_UNLOCK_DAYS)
    if (Number.isFinite(rawDays) && rawDays > 0) {
        return rawDays
    }
    return DEFAULT_UNLOCK_DAYS
}

function createUnlockState() {
    const expiresAt = Date.now() + getUnlockDays() * 24 * 60 * 60 * 1000
    return {
        unlocked: true,
        expiresAt,
    }
}

function readUnlockState(storage) {
    if (!storage) return null

    try {
        const raw = storage.getItem(STORAGE_KEY)
        if (!raw) return null

        const parsed = JSON.parse(raw)
        if (!parsed || !parsed.unlocked || !parsed.expiresAt) {
            storage.removeItem(STORAGE_KEY)
            return null
        }

        if (Date.now() > parsed.expiresAt) {
            storage.removeItem(STORAGE_KEY)
            return null
        }

        return parsed
    } catch {
        storage.removeItem(STORAGE_KEY)
        return null
    }
}

export function isSiteUnlocked() {
    const storage = getStorage()
    return !!readUnlockState(storage)
}

export function unlockSite(password) {
    if (password !== getConfiguredPassword()) {
        return { success: false, message: '密码不正确' }
    }

    const storage = getStorage()
    if (storage) {
        storage.setItem(STORAGE_KEY, JSON.stringify(createUnlockState()))
    }

    return { success: true, message: '已解锁' }
}

export function lockSite() {
    const storage = getStorage()
    if (storage) {
        storage.removeItem(STORAGE_KEY)
    }
}
